import React from "react";
import "./SpinnerLoader.scss";
function DotLoader() {
  return (
    <>
      <div className="loader">Loading...</div>
    </>
  );
}

export default DotLoader;
